export interface ITransactionExcel {
    merchantName: string;
    sourceCard: number | null;
    firstPurchaseDate: string;
    lastDebitDate: string;
    amount: number;
    curency: string;
    status: string;
}

export interface IFilterState {
    card?: any;
    user?: any;
    monthView?: boolean;
    dates?: any;
    date?: string;
}
export enum Currency {
    ILS = 0 || 376,
    USD = 840,
    EUR = 978
}
